import { Injectable } from '@angular/core';
import { isIOS, isIOSNative, isMacOSSafari } from '@common/helper/browser';

import { dynamicFontsSupport } from '@pwa/helper/dynamicFonts';
import { isIndicatorFixApplicable } from '@pwa/helper/homeIndicatorFix';
import { InstallationMode } from '@pwa/model/InstallationMode';

import { ClipboardService } from './clipboard.service';
import { NativeAppService } from './native-app.service';
import { PwaService } from './pwa.service';

@Injectable({ providedIn: 'root' })
export class FeatureService {
    constructor(
        private pwaService: PwaService,
        private clipboardService: ClipboardService,
    ) {
        this.injectStyles();
    }

    get runHidden(): boolean {
        return this.pwaService.getInstallationMode() !== InstallationMode.pwa;
    }

    get nativeNetworkIntegration(): boolean {
        return NativeAppService.supportsNativeNetworkIntegration();
    }

    get nativeClipboard(): boolean {
        return NativeAppService.supportsNativeClipboard();
    }

    private featureStyle(feature: string, value: boolean) {
        return (
            (value ? '' : `.feature-${feature} { display: none }\n`) +
            (!value ? '' : `.no-feature-${feature} { display: none }`)
        );
    }

    private injectStyles(): void {
        const styleTag = document.createElement('style');
        styleTag.textContent = `
            ${this.featureStyle('run-hidden', this.runHidden)}
            ${this.featureStyle('indicator-fix', isIndicatorFixApplicable())}
            ${this.featureStyle('clipboard-integration', this.clipboardService.isSupported())}
            ${this.featureStyle('native-app', isIOSNative)}
            ${this.featureStyle('ios-not-native', isIOS && !isIOSNative)}
            ${this.featureStyle('ios-or-safari', (isIOS && !isIOSNative) || isMacOSSafari)}
            ${this.featureStyle('ios', isIOS)}
            ${this.featureStyle('native-network', this.nativeNetworkIntegration)}
            ${this.featureStyle('dynamic-font-size', dynamicFontsSupport())}
        `;

        document.head.appendChild(styleTag);
    }
}
